import { render } from "./SummaryReportsTable.vue?vue&type=template&id=cf2ccec2&scoped=true"
import script from "./SummaryReportsTable.vue?vue&type=script&lang=js"
export * from "./SummaryReportsTable.vue?vue&type=script&lang=js"

import "./SummaryReportsTable.vue?vue&type=style&index=0&id=cf2ccec2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf2ccec2"]])

export default __exports__